import { REDUX_OPTIONS_TYPES } from './action'

const initialState = {
  options: false,
  initials: {
    internals: [],
    constants: [],
    truck_types: [],
    countries: []
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_OPTIONS_TYPES.OPTIONS:
      return {
        ...state,
        options: action.payload
      }
    case REDUX_OPTIONS_TYPES.INITIALS:
      return {
        ...state,
        initials: action.payload
      }
    default:
      return state
  }
}
